import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sonarCloud = defineConnector({
  identifier: "sonarCloud",
  name: "SonarCloud",
  tagLine: "Cloud code quality and security",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://sonarcloud\\.io/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Generate a token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [SonarCloud security settings](https://sonarcloud.io/account/security) and generate a new token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "SonarCloud token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://sonarcloud.io/api/authentication/validate",
  },
});
